/* eslint-disable import/prefer-default-export */

import { LOCALIZATION_CONFIG } from '../../config/configConsts';

export const formatDate = (date: Date): string => {
  const {
    de: { locale },
  } = LOCALIZATION_CONFIG;
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  };
  return date.toLocaleDateString(locale, options).replaceAll('.', '/');
};

export const formatTime = (date: Date): string => {
  const {
    de: { locale },
  } = LOCALIZATION_CONFIG;
  const options: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
  };
  return date.toLocaleTimeString(locale, options);
};

export const formatDateTime = (date: Date): string => {
  const {
    de: { locale },
  } = LOCALIZATION_CONFIG;
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  };
  return date.toLocaleString(locale, options).replaceAll('.', '/');
};

export const getFormattedDate = (dateString?: string | null): string => {
  if (!dateString) {
    return '';
  }
  const dateValue = new Date(dateString);
  const msTimezoneOffset = dateValue.getTimezoneOffset() * 60 * 1000;
  const globalTimeValue = new Date(dateValue.getTime() - msTimezoneOffset);

  return globalTimeValue.toISOString().split('T')[0];
};

export const isDateString = (value: string): boolean => {
  const date = new Date(value);
  return !isNaN(date.getTime());
};

// Returns a localized date-time string (based on app locale) from a UTC timestamp.
// Accepts ISO timestamp string (e.g., '2024-10-05T14:30:00Z'),
// numeric epoch in seconds or milliseconds, or a Date instance.
export const formatLocalDateTimeFromUtc = (timestamp?: string | number | Date | null): string => {
  if (timestamp === undefined || timestamp === null || timestamp === '') {
    return '';
  }

  let date: Date;

  if (timestamp instanceof Date) {
    date = timestamp;
  } else if (typeof timestamp === 'number') {
    const ms = timestamp < 1e12 ? timestamp * 1000 : timestamp; // seconds -> ms if needed
    date = new Date(ms);
  } else {
    const trimmed = timestamp.trim();
    if (/^\d+(?:\.\d+)?$/.test(trimmed)) {
      const num = Number(trimmed);
      const ms = num < 1e12 ? num * 1000 : num;
      date = new Date(ms);
    } else {
      date = new Date(trimmed);
    }
  }

  if (isNaN(date.getTime())) {
    return '';
  }

  // formatDateTime already formats using locale and returns local time
  return formatDateTime(date);
};

// Alias with a more descriptive name matching issue wording
export const getLocalDateTimeByUtcTimestamp = (timestamp?: string | number | Date | null): string =>
  formatLocalDateTimeFromUtc(timestamp);
